<template>
  <transition v-if="showModal" name="modal">
    <div class="modal-mask" @click="showModal = false">
      <div class="modal-wrapper">
        <div
          :class="{'extra_padding': addNewAddress || addressesLoaded && filteredAddresses.length === 0}"
          class="modal-container"
          @click.stop="doNothing()"
        >
          <div
            v-if="!addNewAddress && addressesLoaded && filteredAddresses.length > 0 || !addressesLoaded"
            :class="{'unselected_bg_color': selectedAddress && selectedAddress.id === -1 || editAddressFromHistory || newAddressModel}"
            class="grid_component"
          >
            <div
              v-for="(address, index) in filteredAddresses"
              :key="index"
              class="address_grid_item pointer"
              @click.stop="setSelectedAddress(address)"
            >
              <vs-radio
                v-model="selectedAddress"
                :vs-name="'selected_address'"
                :vs-value="address"
              />
              <div class="address_top_info">
                <div class="name">
                  <template v-if="!$device.isMobileOrTablet">
                    <span>{{ address.firstName + ' ' + address.lastName }}</span>
                    {{ address.street + ', ' + address.city + ', ' + address.state }}
                  </template>
                  <template v-else>
                    <div>{{ address.firstName + ' ' + address.lastName }}</div>
                    <div>{{ address.street }}</div>
                    <div>{{ address.city + ', ' + address.state }}</div>
                  </template>
                </div>
                <div v-if="!$device.isMobileOrTablet">
                  {{ address.phone + ', ' + address.email }}
                </div>
                <div v-else>
                  <div>{{ address.phone }}</div>
                  <div>{{ address.email }}</div>
                </div>
              </div>
              <div class="edit_icon" @click.stop="editSelectedAddress(address)">
                <img v-lazy-load data-src="/edit.svg">
              </div>
            </div>
          </div>
          <div
            :class="{'unselected_bg_color': !newAddressModel && !editAddressFromHistory}"
            class="new_address_container"
          >
            <div
              class="new_address_top pointer"
              @click.stop="setEmptyAddress()"
            >
              <vs-radio
                v-if="addressesLoaded && filteredAddresses.length > 0 || !addressesLoaded"
                v-model="newAddressModel"
                :vs-name="'selected_address'"
                :vs-value="true"
                class="new-address-radio"
              />
              <div class="stana">
                <div :class="{'stana-label': addressesLoaded && filteredAddresses.length > 0 || !addressesLoaded}">
                  {{
                    addNewAddress && (!stripe || stripe.data.length > 0) ? 'Add new address' : !(addressesLoaded && filteredAddresses.length > 0 || !addressesLoaded) ? 'SHIPPING ADDRESS' : 'Ship to a new address'
                  }}
                </div>
                <div class="spacer" />
                <div
                  v-if="stripe && stripe.data.length > 0 && !(addressesLoaded && filteredAddresses.length > 0 || !addressesLoaded)"
                  class="same_address"
                >
                  <div class="same_address_lable">
                    Same as Billing address
                  </div>
                  <label class="switch">
                    <input v-model="sameAddress" :checked="sameAddress" type="checkbox" @change="toggleSameAddress()">
                    <span class="gotit_slider round" />
                  </label>
                </div>
              </div>
            </div>
            <div v-if="newAddressModel || editAddressFromHistory" class="form user_version">
              <div class="row_flex">
                <div>
                  <span class="placeholder">Full Name:</span>
                  <input
                    v-model="name"
                    :class="{'validation_error' : nameError}"
                    placeholder="Full Name"
                    class="gotit_input"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
                <div>
                  <span v-if="!showInvalidEmailError" class="placeholder">Email:</span>
                  <span v-else class="placeholder invalid_email">Invalid email address:</span>
                  <input
                    v-model="email"
                    :class="{'validation_error' : emailError}"
                    placeholder="Email"
                    class="gotit_input"
                    type="email"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
              </div>
              <div class="row_flex">
                <div>
                  <span class="placeholder">Address Line 1:</span>
                  <!-- :autocompleteText="selectedAutocompleteAddress" -->
                  <vue-google-autocomplete
                    id="map"
                    ref="ac"
                    :country="'US'"
                    class="gotit_input"
                    classname="form-control"
                    placeholder="Address Line 1"
                    @placechanged="getAddressData"
                    @keyup="inputChanged"
                  />
                  <!--                  v-if="$device.isIos"-->
                  <!--                  <input
                    v-model="street"
                    :class="{'validation_error' : streetError}"
                    placeholder="Address Line 1"
                    class="gotit_input"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >-->
                </div>
                <div>
                  <span class="placeholder">{{
                    $device.isMobileOrTablet ? 'Apartment (optional)' : 'Apartment, suite, etc.(optional)'
                  }}</span>
                  <input
                    ref="addressLineTwo"
                    v-model="addressLine2"
                    placeholder="Apartment, suite, etc."
                    class="gotit_input"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
              </div>
              <div class="row_flex">
                <div>
                  <span class="placeholder margin">City:</span>
                  <input
                    v-model="city"
                    :class="{'validation_error' : cityError}"
                    placeholder="City"
                    class="gotit_input"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
                <div v-if="country === 'US'" class="state">
                  <label>State:</label>
                  <span class="trick-select option">
                    <select v-model="state" :class="{'select_validation_error' : stateError}">
                      <option value="" disabled selected>
                        Select State
                      </option>
                      <option value="AL">
                        AL
                      </option>
                      <option value="AK">
                        AK
                      </option>
                      <option value="AR">
                        AR
                      </option>
                      <option value="AZ">
                        AZ
                      </option>
                      <option value="CA">
                        CA
                      </option>
                      <option value="CO">
                        CO
                      </option>
                      <option value="CT">
                        CT
                      </option>
                      <option value="DC">
                        DC
                      </option>
                      <option value="DE">
                        DE
                      </option>
                      <option value="FL">
                        FL
                      </option>
                      <option value="GA">
                        GA
                      </option>
                      <option value="HI">
                        HI
                      </option>
                      <option value="IA">
                        IA
                      </option>
                      <option value="ID">
                        ID
                      </option>
                      <option value="IL">
                        IL
                      </option>
                      <option value="IN">
                        IN
                      </option>
                      <option value="KS">
                        KS
                      </option>
                      <option value="KY">
                        KY
                      </option>
                      <option value="LA">
                        LA
                      </option>
                      <option value="MA">
                        MA
                      </option>
                      <option value="MD">
                        MD
                      </option>
                      <option value="ME">
                        ME
                      </option>
                      <option value="MI">
                        MI
                      </option>
                      <option value="MN">
                        MN
                      </option>
                      <option value="MO">
                        MO
                      </option>
                      <option value="MS">
                        MS
                      </option>
                      <option value="MT">
                        MT
                      </option>
                      <option value="NC">
                        NC
                      </option>
                      <option value="NE">
                        NE
                      </option>
                      <option value="NH">
                        NH
                      </option>
                      <option value="NJ">
                        NJ
                      </option>
                      <option value="NM">
                        NM
                      </option>
                      <option value="NV">
                        NV
                      </option>
                      <option value="NY">
                        NY
                      </option>
                      <option value="ND">
                        ND
                      </option>
                      <option value="OH">
                        OH
                      </option>
                      <option value="OK">
                        OK
                      </option>
                      <option value="OR">
                        OR
                      </option>
                      <option value="PA">
                        PA
                      </option>
                      <option value="RI">
                        RI
                      </option>
                      <option value="SC">
                        SC
                      </option>
                      <option value="SD">
                        SD
                      </option>
                      <option value="TN">
                        TN
                      </option>
                      <option value="TX">
                        TX
                      </option>
                      <option value="UT">
                        UT
                      </option>
                      <option value="VT">
                        VT
                      </option>
                      <option value="VA">
                        VA
                      </option>
                      <option value="WA">
                        WA
                      </option>
                      <option value="WI">
                        WI
                      </option>
                      <option value="WV">
                        WV
                      </option>
                      <option value="WY">
                        WY
                      </option>
                    </select>
                  </span>
                </div>
                <div v-else class="state">
                  <span class="state placeholder">State:</span>
                  <input
                    v-model="state"
                    placeholder="State / Province / district"
                    class="state gotit_input"
                    type="text"
                  >
                </div>
              </div>
              <div class="row_flex">
                <div class="country">
                  <p>
                    <label>Country:</label>
                    <span class="trick-select option">
                      <select v-model="country">
                        <option v-for="country of countries" :key="country.value" :value="country.value">
                          {{ country.name }}
                        </option>
                        <!--<option value="UK">
                          United Kingdom
                        </option>-->
                        <!--                        <option value="CANADA">
                          Canada
                        </option>-->
                      </select>
                    </span>
                  </p>
                </div>
                <div class="zip">
                  <span class="placeholder margin">Zip:</span>
                  <input
                    v-model="zip"
                    :class="{'validation_error' : zipError}"
                    placeholder="Zip"
                    class="gotit_input"
                    type="tel"
                  >
                </div>
                <div>
                  <span class="placeholder margin">Phone:</span>
                  <input
                    v-model="phone"
                    :class="{'validation_error' : phoneError}"
                    placeholder="Phone"
                    class="gotit_input"
                    type="tel"
                  >
                </div>
              </div>
            </div>

            <div v-if="newAddressModel || editAddressFromHistory" class="form sean_version">
              <div class="row_flex">
                <div>
                  <span class="placeholder">Full Name:</span>
                  <input
                    v-model="name"
                    :class="{'validation_error' : nameError}"
                    placeholder="Full Name"
                    class="gotit_input"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
              </div>
              <div>
                <div>
                  <span v-if="!showInvalidEmailError" class="placeholder">Email:</span>
                  <span v-else class="placeholder invalid_email">Invalid email address:</span>
                  <input
                    v-model="email"
                    :class="{'validation_error' : emailError}"
                    placeholder="Email"
                    class="gotit_input"
                    type="email"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
              </div>
              <div>
                <span class="placeholder">Address Line 1:</span>
                <input
                  v-model="street"
                  :class="{'validation_error' : streetError}"
                  placeholder="Address Line 1"
                  class="gotit_input"
                  @focusin="keyboardOpen = true"
                  @focusout="keyboardOpen = false"
                >
              </div>
              <div>
                <span class="placeholder">{{
                  $device.isMobileOrTablet ? 'Apartment (optional)' : 'Apartment, suite, etc.(optional)'
                }}</span>
                <input
                  v-model="addressLine2"
                  placeholder="Apartment, suite, etc."
                  class="gotit_input"
                  @focusin="keyboardOpen = true"
                  @focusout="keyboardOpen = false"
                >
              </div>
              <div class="row_flex">
                <div>
                  <span class="placeholder margin">City:</span>
                  <input
                    v-model="city"
                    :class="{'validation_error' : cityError}"
                    placeholder="City"
                    class="gotit_input"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
                <span class="city_spacer" />
                <div v-if="country === 'US'" class="state">
                  <label>State:</label>
                  <span class="trick-select option">
                    <select v-model="state" :class="{'select_validation_error' : stateError}">
                      <option value="" disabled selected>
                        Select State
                      </option>
                      <option value="AL">
                        AL
                      </option>
                      <option value="AK">
                        AK
                      </option>
                      <option value="AR">
                        AR
                      </option>
                      <option value="AZ">
                        AZ
                      </option>
                      <option value="CA">
                        CA
                      </option>
                      <option value="CO">
                        CO
                      </option>
                      <option value="CT">
                        CT
                      </option>
                      <option value="DC">
                        DC
                      </option>
                      <option value="DE">
                        DE
                      </option>
                      <option value="FL">
                        FL
                      </option>
                      <option value="GA">
                        GA
                      </option>
                      <option value="HI">
                        HI
                      </option>
                      <option value="IA">
                        IA
                      </option>
                      <option value="ID">
                        ID
                      </option>
                      <option value="IL">
                        IL
                      </option>
                      <option value="IN">
                        IN
                      </option>
                      <option value="KS">
                        KS
                      </option>
                      <option value="KY">
                        KY
                      </option>
                      <option value="LA">
                        LA
                      </option>
                      <option value="MA">
                        MA
                      </option>
                      <option value="MD">
                        MD
                      </option>
                      <option value="ME">
                        ME
                      </option>
                      <option value="MI">
                        MI
                      </option>
                      <option value="MN">
                        MN
                      </option>
                      <option value="MO">
                        MO
                      </option>
                      <option value="MS">
                        MS
                      </option>
                      <option value="MT">
                        MT
                      </option>
                      <option value="NC">
                        NC
                      </option>
                      <option value="NE">
                        NE
                      </option>
                      <option value="NH">
                        NH
                      </option>
                      <option value="NJ">
                        NJ
                      </option>
                      <option value="NM">
                        NM
                      </option>
                      <option value="NV">
                        NV
                      </option>
                      <option value="NY">
                        NY
                      </option>
                      <option value="ND">
                        ND
                      </option>
                      <option value="OH">
                        OH
                      </option>
                      <option value="OK">
                        OK
                      </option>
                      <option value="OR">
                        OR
                      </option>
                      <option value="PA">
                        PA
                      </option>
                      <option value="RI">
                        RI
                      </option>
                      <option value="SC">
                        SC
                      </option>
                      <option value="SD">
                        SD
                      </option>
                      <option value="TN">
                        TN
                      </option>
                      <option value="TX">
                        TX
                      </option>
                      <option value="UT">
                        UT
                      </option>
                      <option value="VT">
                        VT
                      </option>
                      <option value="VA">
                        VA
                      </option>
                      <option value="WA">
                        WA
                      </option>
                      <option value="WI">
                        WI
                      </option>
                      <option value="WV">
                        WV
                      </option>
                      <option value="WY">
                        WY
                      </option>
                    </select>
                  </span>
                </div>
                <div v-else class="state">
                  <span class="state placeholder">State:</span>
                  <input
                    v-model="state"
                    placeholder="State / Province / district"
                    class="state gotit_input"
                    type="text"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
              </div>
              <div class="row_flex">
                <div class="country">
                  <p>
                    <label>Country:</label>
                    <span class="trick-select option">
                      <select v-model="country">
                        <option value="US">
                          United States
                        </option>
                        <!--<option value="UK">
                          United Kingdom
                        </option>-->
                        <!--                        <option value="CANADA">
                                                  Canada
                                                </option>-->
                      </select>
                    </span>
                  </p>
                </div>
                <div class="zip">
                  <span class="placeholder margin">Zip:</span>
                  <input
                    v-model="zip"
                    :class="{'validation_error' : zipError}"
                    placeholder="Zip"
                    class="gotit_input"
                    type="tel"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
                <div>
                  <span class="placeholder margin">Phone:</span>
                  <input
                    v-model="phone"
                    :class="{'validation_error' : phoneError}"
                    placeholder="Phone"
                    class="gotit_input"
                    type="tel"
                    @focusin="keyboardOpen = true"
                    @focusout="keyboardOpen = false"
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            :class="{'please_wait': pleaseWait}"
            class="gotit_button select_address"
            @click="deliverSelectedAddress()"
          >
            <div class="select_address_text">
              {{ pleaseWait ? 'Please Wait...' : addNewAddress ? 'Add this address' : 'Ship to this address' }}
            </div>
          </div>
          <div class="bottom_space" :class="{'show': newAddressModel && keyboardOpen}">
            <div>Powered by GOTit</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import GridComponent from '~/components/GridComponent'

export default {
  name: 'EditAddressDialogComponent',
  // eslint-disable-next-line vue/no-unused-components
  components: { GridComponent },
  data () {
    return {
      lastDraftOrder: null,
      pleaseWait: false,
      addNewAddress: false,
      sameAddress: false,
      stripe: null,
      showModal: false,
      selectedAddressFromHistory: null,
      editMode: false,
      editAddressFromHistory: false,
      state: '',
      name: '',
      city: '',
      addressData: null,
      event: null,
      autoCompleteStream: new Subject(),
      everKeyUp: false,
      selectedAutocompleteAddress: null,
      selectedAutocompleteAddressStr: null,
      autoCompleteAddressChanges: '',
      items: [],
      street: '',
      addressLine2: '',
      phone: '',
      zip: '',
      email: '',
      countries: [{ name: 'United States', value: 'US' }],
      country: 'US',
      addressHistory: [],
      addressesLoaded: false,
      selectedAddress: null,
      newAddressModel: false,
      nameError: false,
      cityError: false,
      phoneError: false,
      emailError: false,
      showInvalidEmailError: false,
      keyboardOpen: false,
      zipError: false,
      stateError: false,
      streetError: false,
      reg: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  computed: {
    filteredAddresses () {
      return this.addressHistory.filter((address) => {
        return address.city && address.city !== 'TEMP'
      })
    }
  },
  watch: {
    selectedAutocompleteAddress (newVal, oldVal) {
      if (newVal && newVal.structured_formatting) {
        this.street = newVal.structured_formatting.main_text
        this.$store.dispatch('api/trackEvent', {
          eventName: 'autocomplete_address_clicked'
        }).then().catch()
        const addressDetails = newVal.structured_formatting.secondary_text.split(',')
        this.$store.dispatch('api/getAddressInfo', newVal.place_id)
          // eslint-disable-next-line camelcase
          .then((address_details) => {
            for (let i = 0; i < address_details.result.address_components.length; i++) {
              const detail = address_details.result.address_components[i]
              if (detail.types.includes('postal_code')) {
                this.zip = detail.short_name || ''
              } else if (detail.types.includes('administrative_area_level_1')) {
                this.state = detail.short_name || ''
              } else if (detail.types.includes('sublocality_level_1') || detail.types.includes('sublocality')) {
                this.city = detail.short_name || ''
              } else if (detail.types.includes('country')) {
                this.country = detail.short_name || ''
              }
            }
          })
          .catch(error => console.log('error', error))
        for (const addressDetailsKey in addressDetails) {
          if (isNaN(addressDetails[addressDetailsKey])) {
            const detail = addressDetails[addressDetailsKey].trim()
            if (detail === 'USA') {
              this.country = detail
            } else if (detail.length === 2) {
              this.state = detail
            } else {
              this.city = detail
            }
          } else {
            // some number, zip?
          }
        }
        this.$refs.addressLineTwo.focus()
      } else {
        this.street = newVal
      }
    },
    autoCompleteAddressChanges (newVal, oldVal) {
      this.autoCompleteStream.next(this.autoCompleteAddressChanges)
    },
    newAddressModel (newVal, oldVal) {
    },
    selectedAddress (newVal, oldVal) {
      if (newVal && !this.editMode) {
        this.editMode = true
        this.newAddressModel = null
      }
    }
  },
  mounted () {
    this.$root.$on('toggle_edit_address', async (lastDraftOrder, meta) => {
      this.clearFormErrors()
      this.lastDraftOrder = lastDraftOrder
      this.initModal(meta)
      this.addressHistory = await this.$store.dispatch('api/getAddressesHistoryFromCache')
      this.addressHistory = this.addressHistory.filter((address) => {
        return address.city && address.city !== 'TEMP'
      })
      if (this.addressHistory.length > 0) {
        this.lastAddress = this.addressHistory[0]
      } else {
        this.newAddressModel = true
      }
      if (this.addressHistory || this.addressHistory.length === 0) {
        this.$store.dispatch('api/trackEvent', {
          eventName: 'add_first_address',
          params: {
            path: this.$route.path
          }
        }).then().catch()
      } else if (this.addressHistory.length > 0) {
        this.$store.dispatch('api/trackEvent', {
          eventName: 'add_address',
          params: {
            path: this.$route.path
          }
        }).then().catch()
      }
      if (this.addressHistory.length === 0) {
        this.selectedAddress = { id: -1 }
        this.setEmptyAddress()
      } else if (this.lastDraftOrder) {
        const name = this.lastDraftOrder.deliverFullName
        const city = this.lastDraftOrder.deliverCity
        const street = this.lastDraftOrder.deliverStreet
        const state = this.lastDraftOrder.deliverState
        const zip = this.lastDraftOrder.deliverZipCode
        const phone = this.lastDraftOrder.deliverPhone || ''
        const email = this.lastDraftOrder.deliverEmail
        const country = this.lastDraftOrder.deliverCountry
        const address = {
          name,
          city,
          street,
          state,
          zip,
          phone,
          email,
          country
        }
        let indexToMove = 0
        this.addressHistory.forEach((filteredAddress, index) => {
          const name = filteredAddress.firstName + ' ' + filteredAddress.lastName
          const city = filteredAddress.city
          const street = filteredAddress.street
          const state = filteredAddress.state
          const zip = filteredAddress.zip
          const email = filteredAddress.email
          const phone = filteredAddress.phone || ''
          const country = filteredAddress.deliverCountry
          // eslint-disable-next-line no-unused-vars
          const fltrdAddress = {
            name,
            city,
            street,
            state,
            zip,
            phone,
            email,
            country
          }
          if (JSON.stringify(fltrdAddress) === JSON.stringify(address)) {
            indexToMove = index
          }
        })

        this.moveCurrentAddressToTop(this.addressHistory, indexToMove, 0)
        this.selectedAddress = this.addressHistory[0]
      }
      this.addressesLoaded = true
      this.initData()
      this.autoCompleteStream
        .pipe(debounceTime(400))
        .subscribe((street) => {
          if (street === '' || street.length < 4) {
            this.items = []
            return
          }
          this.$store.dispatch('api/trackEvent', {
            eventName: 'autocomplete_address_api_call',
            params: {
              chars: this.autoCompleteAddressChanges.length
            }
          }).then().catch()
          this.$store.dispatch('api/getAddressAutoComplete', this.autoCompleteAddressChanges)
            .then((result) => {
              this.items = []
              for (const prediction of result.predictions) {
                const place = {}
                place.text = prediction.description
                place.place = prediction
                this.items.push(place)
              }
            })
            .catch(error => console.log('error', error))
        })
    })
  },
  methods: {
    inputChanged (newInput) {
      this.street = this.$refs.ac.autocompleteText
      this.$store.dispatch('api/trackEvent', {
        eventName: 'autocomplete_address_typed',
        params: {
          chars: this.street.length
        }
      }).then().catch()
    },
    getAddressData (data) {
      this.$store.dispatch('api/trackEvent', {
        eventName: 'autocomplete_address_clicked'
      }).then().catch()
      this.addressData = data
      this.state = data.administrative_area_level_1
      if (data.country !== 'United States') {
        this.countries.push({ name: data.country, value: data.country })
        this.country = data.country
      } else {
        this.country = 'US'
      }

      this.city = data.locality
      this.zip = data.postal_code
      if (this.addressData == null) {
        this.addressData = { street_number: '', route: this.street }
      }
      if (this.addressData.street_number) {
        this.selectedAutocompleteAddressStr = this.addressData.street_number + ' '
      } else {
        this.selectedAutocompleteAddressStr = ''
      }
      if (this.addressData.route) {
        this.selectedAutocompleteAddressStr += this.addressData.route
      }

      this.$refs.addressLineTwo.focus()
      this.selectedAutocompleteAddress = this.selectedAutocompleteAddressStr
      this.street = this.selectedAutocompleteAddress
      setTimeout(() => {
        if (this.$refs.ac) {
          this.$refs.ac.update(this.selectedAutocompleteAddress)
        }
      }, 600)
    },
    customFilter (item, queryText, itemText) {
      return true
    },
    fetchAutoCompleteAddress (search) {
      if (search && this.everKeyUp) {
        this.street = search
        this.autoCompleteAddressChanges = search
        this.$store.dispatch('api/trackEvent', {
          eventName: 'autocomplete_address_typed',
          params: {
            chars: this.autoCompleteAddressChanges
          }
        }).then().catch()
      }
    },
    toggleSameAddress () {
      if (this.sameAddress && this.stripe && this.stripe.data.length > 0 &&
        !((this.addressesLoaded && this.filteredAddresses.length > 0) || !this.addressesLoaded)) {
        const address = this.stripe.data[0]
        this.name = address.name
        this.city = address.addressCity
        this.street = address.addressLine1
        this.selectedAutocompleteAddressStr = address.addressLine1
        if (this.$refs.ac) {
          this.$refs.ac.update(this.selectedAutocompleteAddress)
        } else {
          this.items = []
          this.items.push(this.selectedAutocompleteAddressStr)
          this.selectedAutocompleteAddress = this.selectedAutocompleteAddressStr
          this.street = this.selectedAutocompleteAddressStr
          setTimeout(() => {
            if (this.$refs.ac) {
              this.$refs.ac.update(this.selectedAutocompleteAddress)
            }
          }, 600)
        }
        this.addressLine2 = address.addressLine2
        this.state = address.addressState
        this.zip = address.addressZip
        this.phone = ''
        this.email = ''
        this.country = address.addressCountry || 'US'
        this.deliverSelectedAddress()
      } else {
        this.clearFormErrors()
        this.name = ''
        this.city = ''
        this.street = ''
        this.selectedAutocompleteAddress = ''
        if (this.$refs.ac) {
          this.$refs.ac.update(this.selectedAutocompleteAddress)
        } else {
          this.items = []
        }
        this.addressLine2 = ''
        this.state = ''
        this.zip = ''
        this.phone = ''
        this.email = ''
        this.country = 'US'
      }
    },
    detectErrors () {
      if (!this.name.trim()) {
        this.nameError = true
      }
      if (!this.city.trim()) {
        this.cityError = true
      }
      if (!this.street.trim()) {
        this.streetError = true
      }
      if (!this.state) {
        this.stateError = true
      }
      if (!this.zip) {
        this.zipError = true
      }
      if (!this.email || !this.isEmailValid(this.email)) {
        this.emailError = true
      }
      if (this.email && !this.isEmailValid(this.email)) {
        this.showInvalidEmailError = true
      }
      if (!this.phone) {
        this.phoneError = true
      }
    },
    isFormValid () {
      return this.name.trim() &&
        this.city.trim() &&
        this.street.trim() &&
        this.state.trim() &&
        this.zip.trim() &&
        this.email.trim() &&
        this.isEmailValid(this.email) &&
        this.phone.trim()
    },
    isEmailValid (email) {
      return this.reg.test(email)
    },
    filteredAddressesFnc () {
      return this.addressHistory.filter((address) => {
        return address.city && address.city !== 'TEMP'
      })
    },
    moveCurrentAddressToTop (arr, oldIndex, newIndex) {
      if (newIndex >= arr.length) {
        let k = newIndex - arr.length + 1
        while (k--) {
          arr.push(undefined)
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
      return arr // for testing
    },
    editSelectedAddress (address) {
      this.selectedAddress = address
      this.selectedAddressFromHistory = address
      this.editAddressFromHistory = true
      this.newAddressModel = null
      this.initData()
    },
    setSelectedAddress (address) {
      this.selectedAddress = address
      this.newAddressModel = null
      this.editAddressFromHistory = false
    },
    setEmptyAddress () {
      this.selectedAddress = null
      this.newAddressModel = true
      this.initData()
    },
    initModal (meta) {
      this.selectedAddress = null
      this.everKeyUp = false
      this.stripe = meta.stripe
      this.sameAddress = !!(this.stripe && this.stripe.data.length > 0)
      this.newAddressModel = false
      if (!this.lastDraftOrder) {
        this.addNewAddress = true
        this.newAddressModel = true
      }
      this.pleaseWait = false
      this.addressesLoaded = false
      this.editAddressFromHistory = false
      this.editMode = false
      this.showModal = true
    },
    clearFormErrors () {
      this.nameError = false
      this.cityError = false
      this.phoneError = false
      this.emailError = false
      this.showInvalidEmailError = false
      this.zipError = false
      this.stateError = false
      this.streetError = false
    },
    async deliverSelectedAddress () {
      this.clearFormErrors()
      if (this.selectedAddress && this.selectedAddress.id === -1) {
        await this.saveThisAddress()
      } else if (!this.isFormValid()) {
        this.detectErrors()
      } else {
        this.pleaseWait = true
        let address = {}
        if (this.selectedAddress && !this.editAddressFromHistory) {
          address = this.selectedAddress
        } else {
          const nameArr = this.name.trim().split(' ')
          address.firstName = nameArr[0]
          address.lastName = nameArr.slice(1, nameArr.length).join(' ')
          address.street = (this.street.trim() + ' ' + this.addressLine2.trim()).trim()
          address.street2 = this.addressLine2.trim()
          address.city = this.city.trim()
          address.state = this.state.trim()
          address.zip = this.zip.trim()
          address.email = this.email.trim()
          address.phone = this.phone.trim()
          address.country = this.country.trim()
        }
        const deliverFirstName = address.firstName
        const deliverLastName = address.lastName
        const deliverStreet = address.street
        const deliverStreet2 = address.street2
        const deliverCity = address.city
        const deliverState = address.state
        const deliverZipCode = address.zip
        const deliverEmail = address.email
        const deliverPhone = address.phone || ''
        const deliverCountry = address.country
        await this.$store.dispatch('api/setCartAddress', {
          deliverFirstName,
          deliverLastName,
          deliverStreet,
          deliverStreet2,
          deliverCity,
          deliverState,
          deliverZipCode,
          deliverEmail,
          deliverPhone,
          deliverCountry
        })
        this.addressHistory = await this.$store.dispatch('api/getUserAddresses')
        this.pleaseWait = false
        this.showModal = false
        this.$emit('addressSet', {
          deliverFirstName,
          deliverLastName,
          deliverStreet,
          deliverStreet2,
          deliverCity,
          deliverState,
          deliverZipCode,
          deliverEmail,
          deliverPhone,
          deliverCountry
        })
        let firebaseEventName = ''
        if (this.newAddressModel) {
          firebaseEventName = 'address_added'
        } else if (this.editAddressFromHistory) {
          firebaseEventName = 'address_edited'
        }
        this.$store.dispatch('api/trackEvent', {
          eventName: firebaseEventName,
          params: {
            path: this.$route.path
          }
        }).then().catch()
        this.$root.$emit('addressSet')
      }
    },
    async saveThisAddress () {
      const nameArr = this.name.split(' ')
      const deliverFirstName = nameArr[0]
      const deliverLastName = nameArr.slice(1, nameArr.length).join(' ')
      const deliverStreet = this.street + ' ' + this.addressLine2
      const deliverStreet2 = this.addressLine2
      const deliverCity = this.city
      const deliverState = this.state
      const deliverZipCode = this.zip
      const deliverEmail = this.email
      const deliverPhone = this.phone || ''
      const deliverCountry = this.country
      await this.$store.dispatch('api/setCartAddress', {
        deliverFirstName,
        deliverLastName,
        deliverStreet,
        deliverStreet2,
        deliverCity,
        deliverState,
        deliverZipCode,
        deliverEmail,
        deliverPhone,
        deliverCountry
      })
      this.pleaseWait = false
      this.showModal = false
      this.$emit('addressSet', {
        deliverFirstName,
        deliverLastName,
        deliverStreet,
        deliverStreet2,
        deliverCity,
        deliverState,
        deliverZipCode,
        deliverEmail,
        deliverPhone,
        deliverCountry
      })
      this.$store.dispatch('api/trackEvent', {
        eventName: 'first_address_added',
        params: {
          path: this.$route.path
        }
      }).then().catch()
    },
    doNothing () {

    },
    initData () {
      if (this.newAddressModel) {
        this.toggleSameAddress()
      } else if (this.editAddressFromHistory) {
        this.name = this.selectedAddressFromHistory.firstName + ' ' + this.selectedAddressFromHistory.lastName
        this.city = this.selectedAddressFromHistory.city
        this.addressLine2 = this.selectedAddressFromHistory.street2 || ''
        this.street = this.selectedAddressFromHistory.street.replace(this.addressLine2, '')
        this.state = this.selectedAddressFromHistory.state
        this.zip = this.selectedAddressFromHistory.zip
        this.email = this.selectedAddressFromHistory.email
        this.phone = this.selectedAddressFromHistory.phone || ''
        this.country = this.selectedAddressFromHistory.country || 'US'
      } else if (this.lastAddress) {
        this.name = this.lastAddress.name
        this.city = this.lastAddress.city
        this.addressLine2 = this.lastAddress.street2 || ''
        this.street = this.lastAddress.street.replace(this.addressLine2, '')
        this.state = this.lastAddress.state
        this.zip = this.lastAddress.zip
        this.phone = this.lastAddress.phone
        this.email = this.lastAddress.email
        this.country = this.lastAddress.country || 'US'
      } else {
        this.toggleSameAddress()
      }
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.mobile_design .modal-wrapper, .mobile_design .modal-mask {
  display: flex;
  align-items: flex-end;
}

.modal-container {
  font-family: HKGroteskRegular, serif;
  width: 600px;
  min-height: 315px;
  margin: 0px auto;
  padding: 1em;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

.mobile_design .modal-container {
  width: 100%;
  max-height: 100%;
  position: fixed;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.grid_component {
  border-radius: 5px 5px 0 0;
  display: flex;
  position: relative;
  z-index: 1;
  /*flex-wrap: nowrap;*/
  flex-direction: column;
  height: 200px;
  overflow-x: hidden;
}

.mobile_design .grid_component {
  display: block;
}

.address_grid_item {
  margin-right: 1em;
  padding: 1em;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
}

.mobile_design .address_grid_item {
  margin-right: 0;
  padding: 0.5em;
}

.mobile_design .name {
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.name {
  font-weight: 700;
  color: #333;
}

.deliver_to_this_address {
  background-color: #ed4956;
  padding: 0.7em;
  border-radius: 5px;
  color: white;
}

.devider {
  height: 1px;
  background-color: #7F828B;
  margin-top: 1em;
}

.form {
  display: flex;
  flex-direction: column;
}

.save_button {
  margin-right: 4em;
}

.please_wait {
  /*color: #198e15;*/
  /*font-size: 1.5em;*/
}

.country select, .state select {
  background: url("/ic_dropdown.svg") #EBECED no-repeat calc(100% - 12px) 50%;
  border: 0;
}

.mobile_design.sean .country select, .mobile_design.sean .state select {
  background: url("/ic_dropdown.svg") white no-repeat calc(100% - 12px) 50%;
  border: 0;
  height: 38px;
}

.mobile_design.sean .trick-select {
  padding-left: 1px;
  padding-right: 1px;
  padding-top: 0;
  height: 38px;
}

.login_input.error {
  border: 1px solid #ed4956;
}

.select_address_text {
  text-align: center !important;
  padding: 0px;
  width: 100%;
}

.mobile_design .trick-select {
  margin-top: 3px;
}

.placeholder {
  display: block;
}

.placeholder.margin {
  margin-bottom: 0.2em;
}

.select_address {
  display: inline-block;
  margin-top: 1em;
}

.new_address_top {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #efefef;
  padding-bottom: 1em;
  margin-bottom: 1em;
  font-family: HKGroteskBold, serif;
  padding-top: 1em;
}

.new-address-radio {
  margin-left: 1em;
}

.new_address_container {
  /*border: 1px solid #efefef;*/
  position: relative;
  background-color: white;
  z-index: 2;
  border-radius: 5px;
  padding: 0;
  margin-top: -14px;
}

.mobile_design.sean .new-address-radio {
  padding-left: 0.5em;
  padding-top: 1.5em;
}

.mobile_design.sean .new_address_container {
  background-color: #EBECED;
  padding: 0;
}

.mobile_design.sean .stana {
  padding: 1em;
  padding-left: 0.5em;
}

.stana-label {
  margin-left: 0.8em;
}

.remove_bottom_margin {
  margin-bottom: 0;
  border-bottom: unset;
  padding-bottom: 0;
}

.unselected_bg_color {
  background-color: #ebeced;
}

.grid_component::-webkit-scrollbar {
  -webkit-appearance: none;
}

.grid_component::-webkit-scrollbar:vertical {
  width: 11px;
}

.grid_component::-webkit-scrollbar:horizontal {
  height: 11px;
}

.grid_component::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white; /* should match background, can't be transparent */
  background-color: rgba(0, 0, 0, .5);
}

.extra_padding {
  padding-top: 2em;
}

.edit_icon img {
  width: 20px;
  height: 20px;
  padding: 4px;
}

.address_grid_item:hover .edit_icon {
  opacity: 1;
}

.edit_icon:hover {
  background: rgba(173, 173, 173, 0.98);
  transition: all 0.4s ease;
}

.edit_icon {
  position: absolute;
  right: 0;
  background: rgba(209, 209, 209, 0.98);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 5px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  text-align: center;
  line-height: 40px;
  vertical-align: middle;
  /*padding: 30px;*/
}

.mobile_design .address_top_info {
  flex-grow: 1;
}

.mobile_design .edit_icon {
  position: relative;
  margin-top: 30px;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.state.placeholder {
  margin-bottom: 2px;
}

.state.gotit_input {
  height: 39px;
}

.row_flex {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.row_flex > div {
  flex-grow: 1;
  max-width: 48.5%;
}

.mobile_design.sean .row_flex > div {
  flex-grow: 1;
  max-width: 100%;
}

.row_flex > div.zip {
  min-width: 80px;
}

.row_flex > div:last-child {
  /*margin-left: 1em;*/
}

.country {
  width: 48.5%;
}

.zip {
  width: 80px;
  margin-left: 1em;
  margin-right: 1em;
}

.invalid_email {
  color: red;
}

.stana {
  margin-left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
}

.same_address {
  display: flex;
  flex-direction: row;
}

.same_address_lable {
  margin-right: 1em;
}

.mobile_design.sean .user_version {
  visibility: hidden;
  height: 0;
}

.sean_version {
  visibility: hidden;
  height: 0;
}

.mobile_design.sean .sean_version {
  visibility: visible;
  height: unset;
}

.mobile_design.sean .gotit_button {
  border-radius: 0;
}

.mobile_design.sean .gotit_input {
  border-radius: 0;
  background-color: white;
}

.mobile_design.sean select {
  border-radius: 0;
}

.new_address_container input:focus {
  outline: 1px solid #f61948;
}

.mobile_design.sean .new_address_container input:focus {
  outline: 1px solid #f61948;
}

.mobile_design.sean .city_spacer {
  width: 10px;
}

.bottom_space {
  visibility: hidden;
  height: 0;
  display: flex;
  align-items: end;
  justify-content: end;
}

.mobile_design.sean .bottom_space {
  height: 0;
  transition: height 0.4s;
}

.mobile_design.sean .bottom_space.show {
  height: 200px;
  transition: height 0.4s;
}

</style>
